module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fXQbv"))).then(() => module.bundle.root('hEqeo'));